import React from "react";

function FormErrorBox({ errors }) {
  if (errors === null || errors === undefined) {
    return null;
  }
  if (Object.keys(errors).length === 0) {
    return null;
  }

  if (typeof errors !== "object") {
    return (
      <article className="message is-danger">
        <div className="message-header">Error(s):</div>
        <div className="message-body">
          <p className="error-message">{errors.message}</p>
        </div>
      </article>
    );
  }

  return (
    <article className="message is-danger">
      <div className="message-header">Error(s):</div>
      <div className="message-body">
        <p className="error-message">{errors.message}</p>
      </div>
    </article>
  );
}

export default FormErrorBox;
